<div align="center">
  <div
    class="preloader-main"
    [class.modal-box]="!overlay"
    [class.overlay]="overlay"
    [ngClass]="customClass">
    <div class="loading">
      <img
        src="https://s3-eu-west-1.amazonaws.com/scopetrackermediastatic/main_load_spinner.gif"
        alt="" />
    </div>
  </div>
</div>
